import { CourseRelevantExecutionDisabledReasonEnum } from '../enums/course-relevant-execution-disabled-reason.enum';
import { IRelevantExecutionSelectionStatusQuery } from '../interfaces/relevant-execution-selection-status.query.interface';

export class RelevantExecutionSelectionStatus {
    isSelectable: boolean;
    disabledReason: CourseRelevantExecutionDisabledReasonEnum;

    constructor(query: IRelevantExecutionSelectionStatusQuery) {
        this.isSelectable = query?.is_selectable ?? true;
        this.disabledReason = query?.disabled_reason;
    }
}
